import { connectMenuItem } from './categories/connect';
import { everythingElseMenuItem } from './categories/everythingElse';
import { portfolioMenuItem } from './categories/portfolio';

export interface MenuItem {
  id: string;
  link: string;
  displayName: string;
  customClasses: string[];
  items: MenuItem[];
  info?: string;
}
export const menuItems: MenuItem[] = [
  portfolioMenuItem,
  connectMenuItem,
  everythingElseMenuItem,
];
